"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletConnectV2Connector = void 0;
const tslib_1 = require("tslib");
const AbstractConnector_1 = require("./AbstractConnector");
const schemas_1 = require("@dcl/schemas");
const configuration_1 = require("../configuration");
class WalletConnectV2Connector extends AbstractConnector_1.AbstractConnector {
    constructor(desiredChainId) {
        super({
            supportedChainIds: (() => {
                const { chains, optionalChains } = WalletConnectV2Connector.configuration.chains[desiredChainId];
                return [...chains, ...optionalChains];
            })()
        });
        this.desiredChainId = desiredChainId;
        this.activate = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const provider = yield Promise.resolve().then(() => tslib_1.__importStar(require('@walletconnect/ethereum-provider'))).then(module => {
                const { chains, optionalChains } = WalletConnectV2Connector.configuration.chains[this.desiredChainId];
                return module.default.init({
                    projectId: WalletConnectV2Connector.configuration.projectId,
                    rpcMap: WalletConnectV2Connector.configuration.urls,
                    chains,
                    optionalChains,
                    showQrModal: true,
                    // Decentraland's RPCs don't support the `test` method used for the ping.
                    disableProviderPing: true,
                    qrModalOptions: {
                        themeVariables: {
                            // Display the WC modal over other Decentraland UI's modals.
                            // Won't be visible without this.
                            '--wcm-z-index': '3000'
                        }
                    },
                    // Methods and events based on what is used on the decentraland dapps and the ethereum-provider lib found at:
                    // https://github.com/WalletConnect/walletconnect-monorepo/blob/v2.0/providers/ethereum-provider/src/constants/rpc.ts
                    // If the wallet doesn't support non optional methods, it will not allow the connection.
                    methods: ['eth_sendTransaction', 'personal_sign'],
                    optionalMethods: [
                        'eth_accounts',
                        'eth_requestAccounts',
                        'eth_sign',
                        'eth_signTypedData_v4',
                        'wallet_switchEthereumChain',
                        'wallet_addEthereumChain'
                    ],
                    events: ['chainChanged', 'accountsChanged'],
                    optionalEvents: ['disconnect']
                });
            });
            const accounts = yield provider.enable();
            provider.on('accountsChanged', this.handleAccountsChanged);
            provider.on('chainChanged', this.handleChainChanged);
            provider.on('disconnect', this.handleDisconnect);
            this.provider = provider;
            return {
                chainId: provider.chainId,
                account: accounts[0],
                provider
            };
        });
        this.getProvider = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.provider) {
                throw new Error('Provider is undefined');
            }
            return this.provider;
        });
        this.getChainId = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.provider) {
                throw new Error('Provider is undefined');
            }
            return this.provider.chainId;
        });
        this.getAccount = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.provider) {
                throw new Error('Provider is undefined');
            }
            return this.provider.accounts[0];
        });
        this.getWalletName = () => {
            var _a, _b;
            return (_b = (_a = this.provider) === null || _a === void 0 ? void 0 : _a.session) === null || _b === void 0 ? void 0 : _b.peer.metadata.name;
        };
        this.deactivate = () => undefined;
        this.close = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.provider) {
                return;
            }
            return this.provider
                .removeListener('accountsChanged', this.handleAccountsChanged)
                .removeListener('chainChanged', this.handleChainChanged)
                .removeListener('disconnect', this.handleDisconnect)
                .disconnect();
        });
        this.handleAccountsChanged = (accounts) => {
            this.emitUpdate({ account: accounts[0] });
        };
        this.handleChainChanged = (chainId) => {
            this.emitUpdate({ chainId });
        };
        this.handleDisconnect = () => {
            if (!this.provider) {
                throw new Error('Provider is undefined');
            }
            return this.emitDeactivate();
        };
    }
}
exports.WalletConnectV2Connector = WalletConnectV2Connector;
WalletConnectV2Connector.configuration = configuration_1.getConfiguration()[schemas_1.ProviderType.WALLET_CONNECT_V2];
WalletConnectV2Connector.clearStorage = (storage) => {
    storage.removeRegExp(new RegExp('^wc@2:'));
};
//# sourceMappingURL=WalletConnectV2Connector.js.map